export default __webpack_public_path__ + "static/media/KneeAngleMidswing.8ea7db81.png";